import axios from 'axios'
import { CreateHouseConsignmentRequest, HouseConsignmentResponse, UpdateHouseConsignmentRequest } from '../../../../api/models'
import { HouseConsignmentResponseV3 } from '../../../../api/models/house-consignment-response-v3'
import { HouseConsignmentDetailsResponseV3 } from '../../../../api/models/house-consignment-details-response-v3'
import { BulkDeleteHouseConsignmentsRequestV3 } from '../../../../api/models/bulk-delete-house-consignments-request-v3'

const baseUrl = process.env.REACT_APP_API_URL

export async function fetchHouseConsignmentsV2(params: { consignmentId: number }, opts?: { signal?: AbortSignal }) {
  const { data } = await axios.get<HouseConsignmentResponse[]>(`${baseUrl}/v2/house-consignment/${params.consignmentId}`, {
    signal: opts?.signal,
  })

  return data
}

export async function fetchHouseConsignmentsV3(params: { consignmentId: number }, opts?: { signal?: AbortSignal }) {
  const { data } = await axios.get<HouseConsignmentResponseV3[]>(`${baseUrl}/v3/house-consignment`, {
    signal: opts?.signal,
    params,
  })

  return data
}

export async function fetchHouseConsignmentV3(id: number, opts?: { signal?: AbortSignal }) {
  const { data } = await axios.get<HouseConsignmentDetailsResponseV3>(`${baseUrl}/v3/house-consignment/${id}`, {
    signal: opts?.signal,
  })

  return data
}

export async function createHouseConsignmentsV2(items: CreateHouseConsignmentRequest[]) {
  const { data } = await axios.post<HouseConsignmentResponse[]>(`${baseUrl}/v2/house-consignment`, items)

  return data
}

export async function updateHouseConsignmentsV2(items: UpdateHouseConsignmentRequest[]) {
  const { data } = await axios.put<HouseConsignmentResponse[]>(`${baseUrl}/v2/house-consignment`, items)

  return data
}

export async function createHouseConsignmentV3(request: CreateHouseConsignmentRequest) {
  const { data } = await axios.post<HouseConsignmentDetailsResponseV3>(`${baseUrl}/v3/house-consignment`, request)

  return data
}

export async function createHouseConsignmentDraftV3(request: CreateHouseConsignmentRequest) {
  const { data } = await axios.post<HouseConsignmentDetailsResponseV3>(`${baseUrl}/v3/house-consignment/draft`, request)

  return data
}

export async function updateHouseConsignmentV3(id: number, request: UpdateHouseConsignmentRequest) {
  const { data } = await axios.put<HouseConsignmentDetailsResponseV3>(`${baseUrl}/v3/house-consignment`, request)

  return data
}

export async function updateHouseConsignmentDraftV3(id: number, request: UpdateHouseConsignmentRequest) {
  const { data } = await axios.put<HouseConsignmentDetailsResponseV3>(`${baseUrl}/v3/house-consignment/draft`, request)

  return data
}

export async function deleteHouseConsignmentV2(id: number) {
  const { data } = await axios.delete<void>(`${baseUrl}/v2/house-consignment/${id}`)

  return data
}

export async function bulkDeleteHouseConsignmentsV3(request: BulkDeleteHouseConsignmentsRequestV3) {
  await axios.delete<void>(`${baseUrl}/v3/house-consignment/bulk-delete`, {
    data: request,
  })
}
